import { LitElement, css, html } from '@lit'
import styles from '@nova/styles'
import { formatPrice, t } from '@nova/utils'

class NovaFreeShippingThreshold extends LitElement {
  static properties = {
    threshold: {
      type: Number,
    },
    cartSubtotal: {
      type: Number,
      state: true,
    },
    percentageValue: {
      type: Number,
      state: true,
    },
  }

  get percentageValue() {
    return (this.cartSubtotal / this.threshold) * 100
  }

  constructor() {
    super()
    document.addEventListener(
      'nova:changeQuantityFinished',
      this._handleUpdateProgressBar
    )
    document.addEventListener('nova:cart:open', this._handleUpdateProgressBar)
    this.threshold = __NOVA_GLOBAL__.freeShippingThreshold
    this._asyncUpdateCart()
  }

  _asyncUpdateCart = async () => {
    try {
      const response = await fetch('/cart.js')
      if (!response.ok) {
        throw new Error('Error fetching cart')
      }
      const data = await response.json()
      this.cartSubtotal = (Number(data.total_price) || 0) / 100
    } catch {
      console.error('Error fetching cart')
    }
  }

  _handleUpdateProgressBar = () => {
    this._asyncUpdateCart()
  }

  _calculateRemaining() {
    return formatPrice((this.threshold - this.cartSubtotal) * 100)
  }

  _displayMessage() {
    let message
    if (this.cartSubtotal >= this.threshold) {
      message = t('cart.general.congrats_on_free_shipping')
    } else {
      message = String(t('cart.general.away_from_free_shipping') || '').replace('{{ away }}', this._calculateRemaining())
    }

    return message
  }

  render() {
    return html`
      <p>${this._displayMessage()}</p>
      <sl-progress-bar value=${this.percentageValue}></sl-progress-bar>
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: block;
        background: var(--nova-color-white);
        padding: var(--nova-space-sm) var(--nova-space-2xs) 0 var(--nova-space-2xs);
        margin-bottom: var(--nova-space-sm) !important;
        border-top: 1px solid var(--nova-brand-grey-100);

        @media screen and (min-width: 768px) {
          padding: var(--nova-space-xs-1) var(--nova-space-xs-1) 0 var(--nova-space-xs-1);
          margin-bottom: var(--nova-space-xs-1) !important;
        }
      }

      p {
        font-size: 14px;
        line-height: 135%;
        margin: 0;
        margin-bottom: 8px;
      }

      sl-progress-bar {
        --height: 2px;
      }

      sl-progress-bar::part(base) {
        background-color: var(--nova-brand-grey-100);
      }

      sl-progress-bar::part(indicator) {
        background-color: var(--nova-color-black);
      }
    `,
  ]
}

customElements.define('nova-free-shipping-threshold', NovaFreeShippingThreshold)
